import React from 'react';
import { Link } from 'react-router-dom';
import elonImage from '../assets/elon.jpg';

const HeroSection = () => {
  return (
    <div className="hero-section">
      <div className="hero-header">
        <div className="elon-image-container">
          <img
            src={elonImage}
            alt="Elon Musk, CEO of Tesla and SpaceX"
            className="elon-image"
            loading="eager"
          />
          <div className="image-overlay"></div>
        </div>
        <div className="hero-text">
          <h2>Genius or Fool?</h2>
          <p>A fact-based analysis examining both sides of Elon Musk's controversial legacy</p>
        </div>
      </div>

      <div className="hero-stats">
        <div className="stat-item genius">
          <span className="stat-label">The Genius</span>
          <ul>
            <li>Built world's most valuable automaker</li>
            <li>SpaceX: ~80% of Earth's orbital payload</li>
            <li>Starlink: Internet to war zones & remote areas</li>
            <li>Paid $11B taxes in 2021 (largest individual payment)</li>
          </ul>
        </div>
        <div className="stat-item fool">
          <span className="stat-label">The Fool</span>
          <ul>
            <li>X/Twitter: 80% value decline since acquisition</li>
            <li>FSD "next year" promised annually since 2016</li>
            <li>Mars mission: 2024 → now 2029-2031</li>
            <li>Multiple SEC violations & ongoing lawsuits</li>
          </ul>
        </div>
      </div>

      <div className="hero-cta">
        <p>Explore the evidence and decide for yourself:</p>
        <div className="cta-buttons">
          <Link to="/issue/failed-promises" className="cta-button primary">Promise vs Reality</Link>
          <Link to="/issue/market-games" className="cta-button secondary">Market Impact</Link>
          <Link to="/about" className="cta-button tertiary">Our Methodology</Link>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
